<div
    class="footer-area text-center border-top-radius box-shadow"
>
    <p>© Nectum</p>
</div>